
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.714 0v5.636H6.42V0C3.159.55.679 3.374.679 6.783c0 2.548 1.39 4.764 3.444 5.957v10.112c0 .631.517 1.148 1.148 1.148h4.59c.632 0 1.149-.517 1.149-1.148V12.74c2.054-1.193 3.443-3.409 3.443-5.957 0-3.409-2.48-6.232-5.739-6.783zm1.148 10.755l-1.148.665v10.284H6.42V11.42l-1.148-.665a4.622 4.622 0 01-2.296-3.972c0-1.147.425-2.226 1.148-3.041v4.19h6.887v-4.19a4.585 4.585 0 011.147 3.041c0 1.63-.883 3.145-2.295 3.972zm13.314 2.915l1.607 1.618-7.495 7.564-3.983-4.017 1.607-1.618 2.376 2.387 5.888-5.934z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.714 0v5.636H6.42V0C3.159.55.679 3.374.679 6.783c0 2.548 1.39 4.764 3.444 5.957v10.112c0 .631.517 1.148 1.148 1.148h4.59c.632 0 1.149-.517 1.149-1.148V12.74c2.054-1.193 3.443-3.409 3.443-5.957 0-3.409-2.48-6.232-5.739-6.783zm1.148 10.755l-1.148.665v10.284H6.42V11.42l-1.148-.665a4.622 4.622 0 01-2.296-3.972c0-1.147.425-2.226 1.148-3.041v4.19h6.887v-4.19a4.585 4.585 0 011.147 3.041c0 1.63-.883 3.145-2.295 3.972zm13.314 2.915l1.607 1.618-7.495 7.564-3.983-4.017 1.607-1.618 2.376 2.387 5.888-5.934z","stroke":"#000"}})])
          )
        }
      }
    